import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";

/**
 * Top yellow promo strip — restored from the original A1 Screening site.
 * Sits above the Dry-Run ribbon (and Storm banner when active).
 */
export default function PromoBar() {
    return (
        <div
            className="w-full"
            style={{ background: "var(--color-cta)", color: "var(--color-cta-ink)" }}
            data-testid="promo-bar"
        >
            <div className="a1-container py-2 flex flex-col sm:flex-row sm:justify-between items-center gap-1 text-xs sm:text-[13px] font-bold uppercase tracking-wider">
                <span className="text-center sm:text-left">
                    Free Estimates · Family-Owned Since 1999
                </span>
                <a
                    href={`tel:${BUSINESS.phoneTel}`}
                    onClick={() => track(EVENTS.PHONE_CLICK, { placement: "promo-bar" })}
                    className="inline-flex items-center gap-1.5 no-underline"
                    style={{ color: "var(--color-cta-ink)" }}
                    data-testid="promo-bar-phone"
                >
                    <Phone size={14} strokeWidth={2.5} />
                    <span>{BUSINESS.phone}</span>
                    <span className="hidden sm:inline">— Call for a Free Estimate</span>
                </a>
            </div>
        </div>
    );
}
